import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  standalone: false
})
export class SearchBarComponent {

  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() search: string = '';

  @Output() searchChange = new EventEmitter<string>();

  @Input() context: 'modal' | 'main' = 'modal'; 
  @Output() clickSearch = new EventEmitter<void>();


  clearSearch() {
    this.search = '';
    this.searchChange.emit('');
  }

}
